<template>
	<div class="flex images-wrap" :style="imagesStyle">
		<div v-for="(img, index) in innerImages" :key="index" class="item">
			<img class="image" :src="$smallImage(img.url)" @click="removeImage(index)" />
		</div>
		<div v-if="canAddImage" @click="selectImage(-1)" class="flex-center item item-add">
			<div class="iconfont icon-zhaoxiangji "></div>
		</div>
	</div>
</template>

<script>
export default {
	cxt: null,
	data() {
		return {
			innerImages: [],
		};
	},
	props: {
		value: {
			type: [String, Array],
			value: () => {
				return 'https://www.inruan.com/static/img/logo.png;https://www.inruan.com/static/img/logo.png'
			}
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		maxCount: {
			type: [String, Number],
			default: 9
		},
		splitChar: { // 分隔符
			type: String,
			default: ';'
		},
		imagesStyle: String
	},
	computed: {
		canAddImage() {
			return !this.disabled && this.innerImages.length < this.maxCount
		}
	},
	watch: {
		value: {
			handler: function (v, ov) {
				if (v !== this.innerValue) {
					// bug.需要$nextTick
					this.$nextTick(function () {
						var imgs = typeof (this.value) == 'string' ? this.value.split(this.splitChar) : this.value;
						this.innerImages = (imgs || []).map(url => {
							return url ? {
								url: url,
							} : null
						}).filter(o => o)
					})
				}
			},
			immediate: true,
		}
	},
	methods: {
		async selectImage(index) {
			if (this.disabled)
				return;
			let res = await this.$chooseImages({
				count: index >= 0 ? 1 : this.maxCount - this.innerImages.length
			})
			if (res && res.tempFilePaths) {
				res.tempFilePaths.map(path => {
					if (this.innerImages.length < this.maxCount) {
						this.innerImages.push({
							url: path
						})
					}
				})
			}
			this.onChange()
		},
		async removeImage(index) {
			if (await this.$query('确定要删除该图片吗？')) {
				this.innerImages.splice(index, 1)
				this.onChange()
			}
		},
		onChange() {
			var imgs = this.innerImages.map(i => {
				return i.url
			})

			if (!this.value || typeof (this.value) == 'string') {
				// 字符串形式
				imgs = imgs.join(this.splitChar)
			}
			this.$emit("input", imgs)
			this.$emit("change", imgs)
		},
	}
}
</script>

<style lang="scss">

.images-wrap {
	flex-wrap: wrap;
	justify-content: end;

	.item {
		// border: 1rpx solid #ced8dc;
		width: 5rem;
		height: 5rem;
		margin-right: 0.375rem;
		margin-bottom: 0.375rem;
		border-color: rgba($color: #000000, $alpha: 0);
		border-radius: 0.375rem;
		overflow: hidden;

		.image {
			width: 5rem;
			height: 5rem;
		}

		&.item-add {
			background-color: #F2F2F2;

			.iconfont {
				font-size: 2rem;
				color: #909090;
			}
		}
	}
}

</style>
